const parseJson = <T>(value: string): T | null => {
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
};

const get = <T>(key: string): T | null => {
  const raw = sessionStorage.getItem(key);
  if (raw === null) return null;
  return parseJson<T>(raw) ?? (raw as unknown as T);
};

const set = <T>(key: string, value: T): void => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

const remove = (key: string): void => {
  sessionStorage.removeItem(key);
};

const clear = (): void => {
  sessionStorage.clear();
};

export const sessionStorageUtil = { get, set, remove, clear } as const;
